import { buildPageConfig } from '../../ui/builders/buildPageConfig';
import { createSelector } from '@reduxjs/toolkit';

export const selectPageConfig = createSelector(
  [
    (state) => state.contest,
    (state) => state.auth,
  ],
  (contestState, authState) => {

    if (contestState.initContestData && authState.initAuthDetails !== null && authState.isAuth !== null) {
      const config = buildPageConfig(contestState, authState);
      return config;
    }
    return null;
  }
);

